import React from "react";
import Aux from "../utils/AuxFunctions";
import Fire from "../config/Fire";
import { withMyDataContext } from "../context/DataProvider";
import ErrorMessage from "../utils/ErrorPages/ErrorMessage";
import SucessMessage from "../utils/ErrorPages/SucessMessage";
import NotLoggedIn from "../utils/ErrorPages/NotLoggedIn";
import ButtonLoader from "../utils/Utilities/ButtonLoader";
import Colors from "../utils/Colors";
import ChevronLeftIcon from "mdi-react/ChevronLeftIcon";
import EmailIcon from "mdi-react/EmailIcon";
import TextInputMaterial from "../utils/Utilities/TextInputMaterial";
import InstagramIcon from "mdi-react/InstagramIcon";
import FacebookIcon from "mdi-react/FacebookIcon";
import TwitterIcon from "mdi-react/TwitterIcon";


class Contact extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            title: "",
            message: "",
            email:"",
            loading: false,
            sucess: false,
            error: "",
        }
    }

    onSubmitContact= async () => {
        if (this.state.loading)
            return;

        if (!this.state.message || !this.state.title || !this.state.email) {
            this.setState({ error: "Must fill all fields" })
            return;
        }

        try {
            this.setState({ loading: true })
            await Fire.shared.sendContactMessage(this.state.email, this.state.title, this.state.message)
            this.setState({sucess:true, loading:false})
           
        } catch (error) {
            Aux.handleError(error)
            this.setState({error: "An error occurred, try again", loading: false})
        }
    }

    goBack = () => {
        try{
            this.props.history.goBack()
        }catch(error){
            Aux.handleError(error)
        }
    }

    render() {

        return (
            <div style={{width:"100%"}}>
            <section className="container">
                <NotLoggedIn active={this.state.loginDialog} onClose={() => this.setState({ loginDialog: false })}></NotLoggedIn>
                <div className="reversed-button-hover" style={{display:"flex", alignItems:"center", marginBottom:20}} onClick={this.goBack}>
                    <ChevronLeftIcon style={{marginRight:5}}></ChevronLeftIcon>
                    <h2>Contact</h2>
                </div>
                <div >
                <div style={{display:"flex", backgroundColor:"#f9f9f9", borderRadius:10, alignItems:"center", justifyContent:"center", padding:"30px 0", flexDirection:"column", marginTop:30, marginBottom:15}}>
                    <div style={{display:"flex"}}>
                        <EmailIcon ></EmailIcon>
                        <span style={{color: Colors.darkText, marginLeft:10, fontSize:16}}>
                            richlessapp@gmail.com
                        </span>
                    </div>
                    <div style={{display:"flex", marginTop:5}}>
                        <InstagramIcon ></InstagramIcon>
                        <span style={{color: Colors.darkText, marginLeft:10, fontSize:16}}>
                            richless.app
                        </span>
                    </div>
                    <div style={{display:"flex", marginTop:5}}>
                        <FacebookIcon ></FacebookIcon>
                        <span style={{color: Colors.darkText, marginLeft:10, fontSize:16}}>
                            richless.app
                        </span>
                    </div>
                    <div style={{display:"flex", marginTop:5}}>
                        <TwitterIcon ></TwitterIcon>
                        <span style={{color: Colors.darkText, marginLeft:10, fontSize:16}}>
                            richlessApp
                        </span>
                    </div>
                </div>
                    <span style={{ color: "#777", alignSelf: "center", fontSize: 14, }}>
                        Send us a message by filling the fields below
                    </span>
                    <ErrorMessage text={this.state.error}></ErrorMessage>
                    <SucessMessage isSucess={this.state.sucess}></SucessMessage>
                    <TextInputMaterial  type="text" title="Email" placeholder="Email or Contact" style={{marginTop:15}}
                        onChange={(e) => {
                            this.setState({ email: e.target.value, error: "" });
                    }}/>
                    <TextInputMaterial  type="text" title="Title" placeholder="Title of the message" style={{marginTop:10}}
                        onChange={(e) => {
                            this.setState({ title: e.target.value, error: "" });
                    }}/>
                    <TextInputMaterial multiline={true} style={{marginTop:10}}
                        type="text" title="Message" rows="4" placeholder="Write your message here..."
                        styleInput={{ resize: "none", height: "100%", padding: 10 }}
                        onChange={(e) => {
                            this.setState({ message: e.target.value });
                        }}/>

                    <ButtonLoader
                        text="Send Message"
                        loading={this.state.loading}
                        style={{ backgroundColor: Colors.mainColor, width: "100%", height:45, marginTop:25 }}
                        // icon={FacebookIcon}
                        isFinished={this.state.sucess}
                        onClick={this.onSubmitContact}
                    ></ButtonLoader>

                </div>
            </section>
            </div>
        );
    }
}

export default withMyDataContext(Contact);